import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { TrustPaymentMethodPage } from './trust-payment-method.page';
import { TrustPaymentMethodPageRoutingModule } from './trust-payment-method-routing.module';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    TranslateModule,
    TrustPaymentMethodPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
  ],
  declarations: [TrustPaymentMethodPage],
  exports: [TrustPaymentMethodPage],
})
export class TrustPaymentMethodPageModule {}
